/*
 * Pause CSS @keyframes animations while their element is off-screen.
 *
 * An animation that keeps ticking below the fold costs a style recalc every frame — and, for a
 * property the compositor can't take (a transform on an SVG, a `width`), a full layout every frame
 * too — all for something nobody can see. That busy main thread is exactly what makes a tap at the
 * TOP of the page wait for the next paint: measured, a rotating "hypoallergenic" seal far down the
 * product page cost 301ms of style+layout out of every 2500ms while the shopper was still up top.
 *
 * Elements marked `data-r69-idle-anim` get the class `r69-anim-off` whenever they are outside the
 * viewport (+300px), which base.css turns into `animation-play-state: paused`. Pausing changes no
 * geometry, so it can never shift the page; and the 300px margin means an element is already
 * running by the time it scrolls into view — no visible pop, no jank. Transitions (hover, etc.) are
 * untouched: `animation-play-state` only governs @keyframes animations.
 */
(function () {
  if (window.__r69IdleAnim) return;
  window.__r69IdleAnim = true;

  var start = function () {
    if (!('IntersectionObserver' in window)) return; /* no observer → leave animations running */

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          entries[i].target.classList.toggle('r69-anim-off', !entries[i].isIntersecting);
        }
      },
      { rootMargin: '300px 0px' }
    );

    var scan = function () {
      var els = document.querySelectorAll('[data-r69-idle-anim]');
      for (var i = 0; i < els.length; i++) {
        if (!els[i].__r69idle) {
          els[i].__r69idle = true;
          els[i].classList.add('r69-anim-off'); /* default paused until the observer reports otherwise */
          io.observe(els[i]);
        }
      }
    };

    scan();
    /* Recently-viewed reveals its section from `hidden` and swaps skeletons for cards after a fetch;
       the marked track element persists, but re-scan once things settle so nothing is missed. */
    window.addEventListener('load', scan);
    setTimeout(scan, 2500);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
